export default class AgendaMinutesFilters {
    constructor(gd) {
        this.grid = gd;
        this.$window   = $(window);
        this.$document = $(document);
        this.sortBy = $('#year');
        this.startDate = null;
        this.endDate = null;
        this.sortBy = $('#year');
        this.loadMoreBtn = $('.load--more');
        this.tabs = $('.agenda--minutes--tab');
        this.bindEvents();
    }

    bindEvents = () => {
        this.$page = 1;
        this.autoLoad = true;
        if($('.daterangepicker-field').length) {
            $(".daterangepicker-field").daterangepicker({
                forceUpdate: true,
                opens: 'left',
                locale: {
                    format: 'D MMM YYYY'
                },
                showDropdowns: true,
            }, (start, end, label)  => {

                this.startDate = start.format('YYYY-MM-DD');
                this.endDate = end.format('YYYY-MM-DD');
                this.delayLoad();
                console.log("A new date selection was made: " + start.format('YYYY-MM-DD') + ' to ' + end.format('YYYY-MM-DD'));
            });
        }

        this.delayLoad();
        this.$window.on('scroll', this.onScroll);
        this.tabs.click(this.delayLoad);
    };
    onScroll = () => {
        let scrollTop = this.$window.scrollTop();
        if (this.getAutoLoader() == 'true' && this.isAtBottom(scrollTop)) {
            this.nextPage();
        }
    };
    delayLoad = () => {
        this.resetPage();
        this.getCurrentGrid().empty();
        this.showLoader();
        clearTimeout(this.timer);
        this.timer = setTimeout(this.filterGrid, 50);
    };
    nextPage = () => {
        this.showLoader();
        clearTimeout(this.timer);
        this.timer = setTimeout(this.loadMore, 50);
    };
    loadMore = () => {
        this.addPage();
        $.ajax({
            dataType: 'json',
            type: 'GET',
            data: {
                page: this.$page,
                type: this.getType(),
                start_date: this.getStartDate(),
                end_date: this.getEndDate(),
                isAjax: true
            },
            url: this.getCurrentPagePath(),
            success: this.appendItems
        });
    };
    appendItems = (response) => {
        if (response.success) {
            let $data = response.data;
            this.hideLoader();
            this.getCurrentGrid().append($data);
        } else {
            this.loadMoreBtn.addClass('hidden');
            this.hideLoader();
            this.setAutoLoader(false);
            this.autoLoad = false;
        }
    };
    filterGrid = () => {
        $.ajax({
            dataType: 'json',
            type: 'GET',
            data: {
                page: this.$page,
                type: this.getType(),
                start_date: this.getStartDate(),
                end_date: this.getEndDate(),
                isAjax: true
            },
            url: this.getCurrentPagePath(),
            success: this.applyFilters
        });
    };
    applyFilters = (response) => {
        let data;
        if (this.grid.length) {
            this.setAutoLoader(true);

            if (!response.success) {
                data = `<div class="text-center not-found"><h3>No Results found</h3></div>`;
                this.loadFlag = true;
            } else {
                data = response.data;
                this.loadFlag = false;
            }
            this.loadFlag ? this.loadMoreBtn.addClass('hidden') : this.loadMoreBtn.removeClass('hidden');
            this.hideLoader();
            this.getCurrentGrid().empty();
            this.getCurrentGrid().append(data);
        }
    };
    isAtBottom = (scrollTop) => {
        return scrollTop + this.$window.height() > this.$document.height() - 350;
    };
    hideLoader = () => {
        this.loadMoreBtn.text(this.loadMoreBtn.data('text'));
    };
    showLoader = () => {
        this.loadMoreBtn.text( this.loadMoreBtn.data('loading-text'));
    };
    addPage = () => {
        this.$page += 1;
    };
    resetPage = () => {
        this.$page = 1;
    };
    getKeywords = () => {
        return this.keywords.val() ? encodeURI(this.keywords.val()) : '';
    };
    getStartDate = () => {
        return this.startDate ? encodeURI(this.startDate) : '';
    };
    getEndDate = () => {
        return this.endDate ? encodeURI(this.endDate) : '';
    };
    getType = () => {
        return this.getCurrentNav().attr('data-type') ? encodeURI(this.getCurrentNav().attr('data-type')) : '';
    };
    getAutoLoader = () => {
        return this.getCurrentNav().attr('data-auto-load') ? encodeURI(this.getCurrentNav().attr('data-auto-load')) : false;
    };
    setAutoLoader = (parameter) => {
        this.getCurrentNav().attr('data-auto-load', parameter);
    };
    getCurrentGrid = () => {
        return this.grid.find('.agenda--minutes--pane.active');
    };
    getCurrentNav = () => {
        return $('.agenda--minutes--tab.active');
    };
    getSortBy = () => {
        return this.sortBy.val() ? encodeURI(this.sortBy.val()) : '';
    };

    getCurrentPagePath = () => {
        return location.href.split('?')[0];
    };

}